<template>
  <el-select
    v-model="deduction"
    :loading="loading"
    :disabled="disable"
    :remote-method="getAll"
    :remote="true"
    :key="key"
    filterable
    clearable
    placeholder="Select Deduction"
    @clear="updateParent"
    @change="updateParent">
    <el-option
      v-for="deduction in deductions"
      :key="deduction.id"
      :value="deduction.id"
      :label="formatDeductionLabel(deduction)">
      <div class="deduction-option">
        <span v-if="deduction.code" class="deduction-option__code">{{ deduction.code }}</span>
        <span class="deduction-option__desc">{{ deduction.desc }}</span>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { Deduction } from '../../../api/payroll/deduction'

export default {
  name: 'SelectDeduction',
  props: {
    deduct: {
      default: null,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      selected: {},
      defaultDeduction: {
        id: -1,
        desc: 'Select Deduction'
      },
      deductions: [],
      deduction: null,
      key: 0
    }
  },
  watch: {
    deduct: function(item) {
      this.deduction = item
      this.deductions = item ? [item] : []
      this.key++
    }
  },
  created() {
    this.deductions = this.deductions.filter(function(element) {
      return element !== undefined
    })
    if (this.deduction) {
      this.deductions = [this.defaultDeduction, this.deduct]
      this.deduction = this.deduct
    }
    this.getDefault()
  },
  methods: {
    formatDeductionLabel(deduction) {
      if (!deduction) return ''
      return deduction.code ? deduction.code + ' - ' + deduction.desc : deduction.desc
    },
    updateParent(id) {
      this.$emit('setDeduction', id)
    },
    getAll(query) {
      if (query.length > 2) {
        this.loading = true
        setTimeout(() => {
          Deduction({ per_page: 999, term: query, notsettings: true }, 'get').then(res => {
            this.deductions = res.data.deduction
            this.loading = false
          }).catch(() => {})
        }, 100)
      } else {
        this.deductions = []
      }
    },
    getDefault(query) {
      this.loading = true
      setTimeout(() => {
        Deduction({ per_page: 999, term: query, notsettings: true }, 'get').then(res => {
          this.deductions = res.data.deduction
          this.loading = false
        }).catch(() => {})
      }, 100)
    }
  }
}
</script>

<style scoped>
.deduction-option {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.deduction-option__code {
  flex: 0 0 auto;
  padding: 2px 6px;
  border: 1px solid #c7d2e2;
  border-radius: 4px;
  color: #25313f;
  background: #f4f7fb;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
}

.deduction-option__desc {
  overflow: hidden;
  color: #303133;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
